/** The second level of Settings' tabs, drawn: the row under "You" and the row under "Organisation".
 *
 * `shell/routeTable.ts` has five tabs for Settings. Three of its screens used to be tabs of their
 * own and are now this row (the table's `under` field keeps the right tab lit while one is open).
 * The lists are in `settingsLinkList.ts`.
 */

import { PageLinks } from "../components/PageLinks";
import { ORGANISATION_LINKS, YOU_LINKS } from "./settingsLinkList";
import type { ScreenSearch } from "./search";

export function YouLinks({ current, search }: { current: string; search: Partial<ScreenSearch> }) {
  return (
    <PageLinks label="Your settings" links={YOU_LINKS} current={current} search={search} testId="you-links" />
  );
}

export function OrganisationLinks({
  current,
  search,
}: {
  current: string;
  search: Partial<ScreenSearch>;
}) {
  return (
    <PageLinks
      label="Organisation"
      links={ORGANISATION_LINKS}
      current={current}
      search={search}
      testId="organisation-links"
    />
  );
}
